export function replaceNonBreakingSpaces(richText: string | null | undefined): string | undefined | null {
  if (!richText) {
    return richText;
  }
  return richText.replace(/&nbsp;/g, ' ');
}
